import { Solution } from '@/src/types/fareFamilyInfo'
import setCommonHeaders from '@/src/utils/rtkQuery/setCommonHeaders'
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'

export interface FareFamilyInfoResponse {
    responseCode: number
    error: any | null
    success: boolean
    data: {
        solutions: Solution[]
        totalDateChangeFee: Record<string, number>
        isAmendable: Record<string, boolean>
        isRefundable: Record<string, boolean>
        refundableAmountOnCancellation: Record<string, number>
    }
    isSuccess: boolean
}

export const fareFamilyApi = createApi({
    reducerPath: 'fareFamilyApi',
    baseQuery: fetchBaseQuery({
        prepareHeaders: (headers, api) => {
            return setCommonHeaders(headers)
        }
    }),

    tagTypes: ['FareFamily'],
    // Keep unused cached data for 10 minutes (600 seconds)
    keepUnusedDataFor: 600,

    endpoints: builder => ({
        getFareFamilyInfo: builder.query<FareFamilyInfoResponse, { itineraryId: string }>({
            query: ({ itineraryId }) => `/itin/${itineraryId}/v2/fare-family-info`,
            transformErrorResponse: (response, meta, arg) => {
                const { status, data } = response
                return {
                    status: status,
                    message: `Fare family info request failed with status ${status}`,
                    itineraryId: arg.itineraryId,
                    data: data || {}
                }
            },
            providesTags: (result, error, { itineraryId }) => [
                { type: 'FareFamily', id: `${itineraryId}-fareFamilyInfo` }
            ]
        })
    })
})

// Export hooks for usage in components
export const { useGetFareFamilyInfoQuery } = fareFamilyApi

// Export the API slice for store configuration
export default fareFamilyApi
